import { useState, useCallback } from 'react'
import { apiClient } from '@/lib/api/client'
import type { ParsedInvoice } from '@/lib/api/types'

interface UseParseInvoiceReturn {
  parse: (imageUrl: string) => Promise<ParsedInvoice | null>
  loading: boolean
  error: string | null
  data: ParsedInvoice | null
  reset: () => void
}

export function useParseInvoice(): UseParseInvoiceReturn {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<ParsedInvoice | null>(null)

  const parse = useCallback(async (imageUrl: string) => {
    setLoading(true)
    setError(null)
    setData(null)

    try {
      const result = await apiClient.parseInvoice(imageUrl)
      setData(result)
      return result
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to parse invoice'
      setError(errorMessage)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setLoading(false)
    setError(null)
    setData(null)
  }, [])

  return { parse, loading, error, data, reset }
}
